// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3ba5e41c","839":"ce30926e","932":"5c9718ad"}[chunkId] + ".chunk.js";
};